/**
 * 数据校验模块统一导出
 */

export { validator, Validator } from "./Validator";
export type { TrackSchema, ValidationResult } from "./Validator";
